import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { PolicyAccordion } from '../../components/PolicyAccordion/index';
import { HeaderBanner } from './HeaderBanner';
import { TableOfContents } from './TableOfContents';
import { QuickLinks } from './QuickLinks';
export function PoliciesPage() {
  return <PageLayout data-id="element-2535">
      <HeaderBanner data-id="element-2536" />
      <TableOfContents data-id="element-2537" />
      <PolicyAccordion data-id="element-2538" />
      <QuickLinks data-id="element-2539" />
    </PageLayout>;
}